import { AbstractPmsApiService } from "./abstract.service";
import { GuestsStatus } from "../models";

/**
 * @class GuestsStatusPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestsStatus>}
 */
export class GuestsStatusPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/guests-status(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestsStatus}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new GuestsStatus(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<GuestsStatus>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {GuestsStatus} status
     * @param {Property} property
     * @returns {Promise.<GuestsStatus>}
     */
    create(status, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, status.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {GuestsStatus} status
     * @returns {Promise.<GuestsStatus>}
     */
    update(status) {
        
        const url = this.url({
            propertyId: status.property.id,
            id:         status.id
        });
        
        return this.http
                   .put(url, status.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {GuestsStatus} status
     * @returns {Promise.<boolean>}
     */
    delete(status) {
        
        const url = this.url({
            propertyId: status.property.id,
            id:         status.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/guests-status.service.js